import type { DrawingLabel } from "@luxalgo/vela";

/**
 * Vertical gap for coincident MA end labels.
 * A fraction of price, so EURUSD (~1.15), an index (~5000), and gold (~2600)
 * each keep the labels inside the candle scale.
 */
export function maEndLabelGap(price: number): number {
  const abs = Math.abs(price);
  return Math.max(abs * 0.0012, 1e-8);
}

export function destackMaEndLabels(labels: DrawingLabel[]): DrawingLabel[] {
  if (labels.length < 2) return labels;
  const sorted = labels.slice().sort((a, b) => Number(a.y) - Number(b.y));
  const out: DrawingLabel[] = [];
  let lastY = Number.NEGATIVE_INFINITY;
  sorted.forEach((label) => {
    let y = Number(label.y);
    if (!Number.isFinite(y)) {
      out.push(label);
      return;
    }
    const gap = maEndLabelGap(Number.isFinite(lastY) ? lastY : y);
    if (y < lastY + gap) y = lastY + gap;
    out.push({ ...label, y });
    lastY = y;
  });
  return out;
}
